/** @jsxImportSource react */
import { Box, Paper, Typography } from '@mui/material'
import BrandName from './BrandName'

/** The centered card of the signed-out pages (sign in, forgot / reset password). */
const AuthCard = ({ subtitle, children }) => (
  <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', p: 2 }}>
    <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 }, width: '100%', maxWidth: 380 }}>
      <BrandName variant="h5" size={34} />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 3 }}>{subtitle}</Typography>
      {children}
    </Paper>
  </Box>
)

export default AuthCard
